import { Container } from '@components/core/container/Container';
import { Paragraph } from '@components/core/paragraph/Paragraph';
import { useACF } from '@context/ACFContext';
import { useIsMobile } from '@hooks/useIsMobile';
import parse from 'html-react-parser';
import MainProductCard from './productCard/MainProductCard';
import MainProductCardMobile from './productCard/MainProductCardMobile';
import CompetitorProductCard from './productCard/CompetitorProductCard';
import MainSimplifiedCard from './productCard/MainSimplifiedCard';
import CompetitorProductCardMobile from './productCard/CompetitorProductCardMobile';
import MainSimplifiedCardMobile from './productCard/MainSimplifiedCardMobile';

const Cards: React.FC = () => {
	// Fetch the post template from the ACF context
	const { postTemplate } = useACF();
	const isMobile = useIsMobile(993);
	// ACF Fields
	const promoParagraph = postTemplate?.review_page_v4_hero_settings?.tr_promo_paragraph;
	const promoParagraphMobile = postTemplate?.review_page_v4_hero_settings?.tr_promo_paragraph_mobile;
  const contentToRender = (isMobile && promoParagraphMobile)
    ? promoParagraphMobile
    : promoParagraph;

	return (
		<Container>
      <Paragraph $linkColor={'#0060C3'} $variant="normal">
        {parse(contentToRender || '')}
      </Paragraph>
			{isMobile ? <MainProductCardMobile /> : <MainProductCard />}
			{isMobile ? <CompetitorProductCardMobile /> : <CompetitorProductCard />}
			{isMobile ? <MainSimplifiedCardMobile /> : <MainSimplifiedCard />}
		</Container>
	);
};

export default Cards;
